// extracted by mini-css-extract-plugin
export default {"generalLoaderWrapper":"styles_generalLoaderWrapper__FuooN","loaderImage":"styles_loaderImage__7VokN","loader":"styles_loader__My8mq","load":"styles_load__sH0wV"};